import React, { useState } from "react";
import "./RenameBookModal.css";

const RenameBookModal = ({ currentName, onClose, onRename }) => {
  const [name, setName] = useState(currentName);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    onRename(name.trim());
  };

  return (
    <>
      <div className="rb-backdrop" onClick={onClose}></div>

      <div className="rb-modal slide-up">

        <div className="rb-header">
          <h3>Rename Book</h3>
          <button className="rb-close" onClick={onClose}>✕</button>
        </div>

        <div className="rb-body">
          <label className="rb-label">New Book Name</label>

          <input
            className="rb-input"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter book name"
            autoFocus
          />

          <div className="rb-actions">
            <button className="rb-btn cancel" onClick={onClose}>Cancel</button>
            <button className="rb-btn save" onClick={handleSubmit}>Save</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RenameBookModal;
